import './topbar.scss'
// import PermIdentityIcon from '@material-ui/icons/PermIdentity'
import LocalPhoneIcon from '@material-ui/icons/LocalPhone';
import MailIcon from '@material-ui/icons/Mail';

function Topbar({open,click}) {
    return (
        <div className={"topbar " + (open && "active")}>

           <div className="wrapper">
              <div className='left'>
              <a href="#intro" className="logo"> 
              <div className="name"> Hirak.</div></a>
 
<div className="itemContainer">

<LocalPhoneIcon className="icon"/>
<span>+91(944) 897-1042/ +1(971) 612-0225</span></div>
<div className="itemContainer">

<MailIcon className="icon"/>
<span> hirakdebnath1@gmail.com</span></div>
              </div>
              
              <div className='right'>
<div className="handburger" onClick={() => click(!open)}>
    <span className='line1'></span>
    <span className='line2'></span>
    <span className='line3'></span>
</div>
              </div> 
           </div>

        </div>
    )
}

export default Topbar
